import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getLoadedStatus } from '../../helpers/loaderHelpers';

// Components
import withLoader from '../../components/Loader/withLoader.js';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact.js';
import analyticsApi from '../../api/analytics';
import HelpCenterLayout from './HelpCenterLayout';
import FAQs from './FAQs/FAQs';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

class HelpCenter extends React.Component {
  state = {
    hasLoaded: false,
  };

  componentDidMount() {
    const { onLoadComplete } = this.props;
    onLoadComplete();
  }

  componentDidUpdate() {
    const { hasLoaded } = this.state;

    if (
      getLoadedStatus(this.getLoadedStatuses(this.props)) == 'LOADED' &&
      !hasLoaded
    ) {
      // Once all required data has loaded, store that fact.
      this.setState({ hasLoaded: true });
    }
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status or the loading has not
    // previously completed.
    const { hasLoaded } = this.state;

    if (
      getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED' ||
      hasLoaded
    ) {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy } = props;
    const loaded = [tenancy.loaded];
    return loaded;
  }

  render() {
    const {
      tenancy,
      goDash,
      toggleContactModal,
      signout,
      inOutage,
      outageFrom,
      outageTo,
      outageMessage,
    } = this.props;

    const failureText = (
      <ReplaceContact
        content={portalContent.APP_ERROR_MESSAGE}
        action={toggleContactModal}
        isLink={true}
      />
    );

    let tenancyData = null;
    if (tenancy.loaded == 'LOADED') {
      tenancyData = tenancy.data;
    }

    const WrappedHelpCenterLayout = withLoader(HelpCenterLayout);

    return (
      <WrappedHelpCenterLayout
        loaded={this.getLoadedStatuses()}
        backAction={goDash}
        faqs={
          <FAQs
            questions={portalFAQs}
            toggleContactModal={toggleContactModal}
            gaEvent={analyticsApi.event}
          />
        }
        failureText={failureText}
        onError={signout}
        inOutage={inOutage}
        outageFrom={outageFrom}
        outageTo={outageTo}
        outageMessage={
          outageMessage && (
            <ReplaceContact
              content={outageMessage}
              action={toggleContactModal}
              isLink={true}
            />
          )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HelpCenter);
